module.exports = __webpack_public_path__ + "static/media/land_white_icon.eea0c54c.svg";